'use client';

import { Routes } from '@common/constants';
import { useUnifiedNavigate } from '@common/hooks/useUnifiedNavigation';
import { StartPage } from '@components/pages/StartPage';
import { useAppSelector } from '@store/hooks';
import { selectIsAdminAllowed, selectIsIndependentDealerAllowed, selectIsMargin } from '@store/selectors';
import { useEffect } from 'react';

export const HomePageClientRenderer = () => {
  const isMargin = false;
  useAppSelector(selectIsMargin);
  const isIndependentDealerAllowed = useAppSelector(selectIsIndependentDealerAllowed);
  const isAdminAllowed = useAppSelector(selectIsAdminAllowed);
  const navigate = useUnifiedNavigate();

  useEffect(() => {
    if (isMargin && !isIndependentDealerAllowed) {
      navigate(Routes.getMarginsPage());
    }
  }, [isMargin, isIndependentDealerAllowed]);

  return <StartPage isAdmin={isAdminAllowed} />;
};
